
export default function CallToAction() {
  return (
    <section className="py-20 sm:py-28 lg:py-36 bg-gradient-to-b from-[#0A0A0A] via-[#0D1117] to-[#000000] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6 leading-tight">
              Ready to Experience<br />
              <span className="text-cyan-400">X Series Excellence?</span>
            </h2>
            <p className="text-lg sm:text-xl text-gray-400 mb-8 leading-relaxed">
              Get in touch with our team to discuss your project requirements, request a detailed quote, 
              or download our comprehensive product brochure.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a
                href="/contact"
                className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-gradient-to-r from-cyan-500 to-cyan-600 text-black text-base font-medium rounded-full hover:from-cyan-400 hover:to-cyan-500 transition-all hover:shadow-[0_0_30px_rgba(0,217,255,0.5)] whitespace-nowrap cursor-pointer"
              >
                <i className="ri-message-3-line text-xl"></i>
                Request a Quote
              </a>
              <a
                href="#"
                className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-black/50 backdrop-blur-sm text-white text-base font-medium rounded-full border border-cyan-500/30 hover:bg-cyan-500/10 hover:border-cyan-500/50 transition-all hover:shadow-[0_0_20px_rgba(0,217,255,0.3)] whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line text-xl text-cyan-400"></i>
                Download Brochure
              </a>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="relative w-full h-[400px] sm:h-[500px] lg:h-[600px] rounded-2xl overflow-hidden border border-cyan-500/20 shadow-[0_0_40px_rgba(0,217,255,0.15)]">
              <img 
                src="/images/ai-professional-business-team-discussing-lu-9f4018.webp"
                alt="Consultation"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
            </div>

            {/* Floating Stats */}
            <div className="absolute bottom-6 left-6 right-6 grid grid-cols-3 gap-4">
              <div className="bg-black/80 backdrop-blur-sm border border-cyan-500/30 rounded-xl p-4 text-center">
                <p className="text-2xl font-bold text-cyan-400">500+</p>
                <p className="text-xs text-gray-400">Projects</p>
              </div>
              <div className="bg-black/80 backdrop-blur-sm border border-cyan-500/30 rounded-xl p-4 text-center">
                <p className="text-2xl font-bold text-cyan-400">98%</p>
                <p className="text-xs text-gray-400">Satisfaction</p>
              </div>
              <div className="bg-black/80 backdrop-blur-sm border border-cyan-500/30 rounded-xl p-4 text-center">
                <p className="text-2xl font-bold text-cyan-400">30+</p>
                <p className="text-xs text-gray-400">Countries</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
